import api from './api';
import { TransferItem } from 'antd/lib/transfer';

export interface PerfilAcesso {
  id: string;
  descricao: string;
  nome: string;
  permissoes: string[];
  codigo: number;
}

export interface Permissao {
  id: string;
  codigo: string;
  nome: string;
}

export interface PerfilAcessoResult {
  id: string;
  codigo: string;
  nome: string;
}

export const getAllPerfil = () => api.get<PerfilAcesso[]>('perfilAcesso');
export const getAllPerfilCrud = () => api.get<PerfilAcesso[]>('perfilAcesso/GetForCrud');
export const getAllPerfilOptions = () => getAllPerfil().then(perfil => (perfil || []).map(t => ({ text: t.nome, value: t.id.toString() })))

export const getAllPerfilFornecedor = () => api.get<PerfilAcesso[]>('perfilAcesso/fornecedor');
export const getAllPerfilFornecedorOptions = () =>
  getAllPerfilFornecedor().then(perfil => (perfil || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const getAllPerfilMrn = () => api.get<PerfilAcesso[]>('perfilAcesso/mrn');
export const getAllPerfilMrnOptions = () =>
  getAllPerfilMrn().then(perfil => (perfil || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const createUser = (perfilAcesso: PerfilAcesso) => api.post<PerfilAcesso>('perfilAcesso', perfilAcesso);
export const Get = (id: string) => api.get(`perfilAcesso/${id}`);
export const updatePerfilAcesso = (perfilAcesso: any[]) =>
  api.put<any>(`perfilAcesso/update/${perfilAcesso.id}`, perfilAcesso);

export const createPerfilAcesso = (perfilAcesso: any) => api.put<any>('perfilAcesso/create', perfilAcesso);

export const getPermissoes = () => api.get<Permissao[]>('perfilAcesso/permissoes');
export const getPermissoesTransfer = () =>
  getPermissoes().then(permissao =>
    (permissao || []).map<TransferItem>(a => ({ key: a.id, title: a.codigo, name: a.codigo })),
  );

export const getAllPerfilAcessoByUsuarioId = (usuarioId: any) => api.get<PerfilAcesso[]>(`perfilAcesso/byUsuarioId/${usuarioId}`);

export const getAllPerfilAcessoAdministradorId = () => api.get<PerfilAcessoResult[]>('perfilAcesso/getAllPerfilAcessoAdministradorId');